import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import customersService from "../services/customersService";
import CustomSpinner from "../components/CustomSpinner";

const TOTAL_VISITS = 10;

export default function PublicCustomer() {
  const { slug } = useParams();
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    customersService.getPublicCustomer(slug)
      .then((response) => setCustomer(response.data))
      .catch((requestError) => setError(requestError.response?.data?.message || "No se pudo cargar la tarjeta."))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <CustomSpinner />;
  if (error) return <main className="flex min-h-screen items-center justify-center bg-rose-50 px-4 text-center text-rose-700">{error}</main>;

  const completedVisits = Math.min(customer.visits, TOTAL_VISITS);
  return (
    <main className="flex min-h-screen items-center justify-center bg-[#fff8f5] px-4 py-8 text-slate-800">
      <section className="relative w-full max-w-md overflow-hidden rounded-[2rem] border border-rose-200 bg-white p-8 text-center shadow-xl shadow-rose-200/50">
        <div className="absolute -right-12 -top-12 h-32 w-32 rounded-full bg-rose-100" />
        <div className="relative">
          <p className="mb-3 text-lg font-semibold text-rose-600">Mictlan Nail&apos;s</p>
          <p className="mb-2 text-sm font-medium uppercase tracking-[0.25em] text-rose-400">Tarjeta de fidelidad</p>
          <h1 className="text-3xl font-semibold text-rose-700">{customer.name}</h1>
          <p className="mt-3 text-slate-500">Completa tus visitas para tener una sesión gratis</p>
          <div className="my-8 grid grid-cols-5 justify-items-center gap-5" aria-label={`${completedVisits} de ${TOTAL_VISITS} visitas completadas`}>
            {Array.from({ length: TOTAL_VISITS }, (_, index) => (
              <span key={index} className={`flex h-10 w-10 items-center justify-center rounded-full border-2 font-bold leading-none ${index === 9 ? "text-[9px]" : index === 4 ? "text-xs" : "text-lg"} ${index < completedVisits ? "border-rose-500 bg-rose-500 text-white" : "border-rose-200 bg-rose-50 text-rose-300"}`}>
                {index === 4 ? "-50%" : index === 9 ? "Gratis" : index < completedVisits ? "✓" : "♡"}
              </span>
            ))}
          </div>
          <p className="text-sm font-medium text-rose-600">{completedVisits} de {TOTAL_VISITS} visitas</p>
          {completedVisits === TOTAL_VISITS && <p className="mt-4 rounded-xl bg-emerald-50 px-4 py-3 text-sm font-medium text-emerald-700">¡Felicidades! Tu sesión gratis está lista.</p>}
        </div>
      </section>
    </main>
  );
}
